import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../../../../store/utility';
import { backend_server_address } from '../../../../../backendServer';

// Online operation-hours / hourmeter status for a machine.
// Backed by the real endpoint GET /api/equipment_nodes/operation_hours/?node=<id>
// (OperationHoursViewSet). Only the hourmeter block is consumed here; the per-timer
// data is not needed for the drawer's running indicator / AGE counter.
export type HourmeterState = 'on' | 'off' | 'unknown' | null;

export interface OperationHoursStatus {
    node: number;
    server_now: string;
    hourmeter: {
        on_seconds_estimate: number | null;
        on_seconds_min: number | null;
        on_seconds_max: number | null;
        blackout_seconds: number | null;
        hourmeter_origin: string | null;
        frozen_through: string | null;
        realtime_through: string | null;
        current_state: HourmeterState;
        current_state_at: string | null;
        unavailable_reason: string | null;
    };
}

export const operationHoursAPI = createApi({
    reducerPath: 'operationHoursApi',
    baseQuery: axiosBaseQuery({ baseUrl: backend_server_address + '/api/equipment_nodes/' }),
    tagTypes: ['OperationHours'],
    endpoints: (builder) => ({
        getOperationHours: builder.query<OperationHoursStatus, number>({
            query: (node) => ({ url: 'operation_hours/', method: 'GET', withCredentials: true, params: { node } }),
            providesTags: (_r, _e, id) => [{ type: 'OperationHours', id }],
        }),
    }),
});

export const { useGetOperationHoursQuery } = operationHoursAPI;
export const operationHoursAPIReducer = operationHoursAPI.reducer;
export const operationHoursAPIReducerPath = operationHoursAPI.reducerPath;
export const operationHoursAPIReducerMiddleware = operationHoursAPI.middleware;
